import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Layout
import Layout from './components/layout/Layout';

// Pages
import Home from './components/Home';
import Login from './components/auth/Login';

// Beneficiaries
import BeneficiaryList from './components/beneficiaries/BeneficiaryList';
import BeneficiaryForm from './components/beneficiaries/BeneficiaryForm';
import BeneficiaryDetail from './components/beneficiaries/BeneficiaryDetail';

// Assistances
import AssistanceList from './components/assistances/AssistanceList';
import AssistanceDetail from './components/assistances/AssistanceDetail';
import AssistanceForm from './components/assistances/AssistanceForm';

// Auth guard - Protege rutas que requieren autenticación
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = localStorage.getItem('accessToken') !== null;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<Login />} />
        
        {/* Rutas protegidas con Layout común */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Home />} />
          
          {/* Rutas de Beneficiarios */}
          <Route path="beneficiaries" element={<BeneficiaryList />} />
          <Route path="beneficiaries/:id" element={<BeneficiaryDetail />} />
          <Route path="beneficiaries/create" element={<BeneficiaryForm />} />
          <Route path="beneficiaries/:id/edit" element={<BeneficiaryForm />} />
          
          {/* Rutas de Asistencias */}
          <Route path="assistances" element={<AssistanceList />} />
          <Route path="assistances/:id" element={<AssistanceDetail />} />
          <Route path="assistances/create" element={<AssistanceForm />} />
          <Route path="assistances/:id/edit" element={<AssistanceForm />} />
          
          {/* Otras rutas */}
          <Route path="users" element={<div>Gestión de Usuarios (pendiente)</div>} />
          <Route path="profile" element={<div>Mi Perfil (pendiente)</div>} />
          <Route path="reports" element={<div>Reportes (pendiente)</div>} />
          
          {/* Ruta 404 para rutas no encontradas */}
          <Route path="*" element={<div>Página no encontrada</div>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
